import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { Divider } from '../../../../Divider'
import { NotificationInline } from '../../../../Notification'
import { Widget } from '../../../../Widget'
import { useApplicantProfileContext } from '../../RentalPortalApplicantProfile.hooks'
import { getIsApplicantWidgetSkeleton } from '../RentalPortalApplicantProfileTabOverview.utils'

import { ApplicantDecisionApplicant } from './ApplicantDecisionApplicant'
import { ApplicantDecisionApprovalStep } from './ApplicantDecisionApprovalStep'
import {
  QA_NAME_APPLICANT_DECISION_CONFLICT,
  QA_NAME_APPLICANT_DECISION_ESCALATION,
  QA_NAME_APPLICANT_DECISION_PANEL,
} from './ApplicantDecisionPanel.constants'
import { useApplicantDecisionAnchor } from './ApplicantDecisionPanel.hooks'
import { getApplicantDecisionEscalationKey } from './ApplicantDecisionPanel.utils.rows'
import { ApplicantDecisionSelectionStep } from './ApplicantDecisionSelectionStep'

import * as styles from './ApplicantDecisionPanel.module.css'

function ApplicantDecisionPanel() {
  const { t } = useTranslation()

  const { applicantData, decisionActions, isInitiated } =
    useApplicantProfileContext()

  const { conflictKey, handleClickAction } = decisionActions

  const isSkeleton = getIsApplicantWidgetSkeleton({
    applicantData,
    isInitiated,
  })

  const anchorRef = useApplicantDecisionAnchor(!isSkeleton)

  const escalationKey = getApplicantDecisionEscalationKey(applicantData)

  return (
    <Widget
      contentContainerProps={{ className: styles.content }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={isSkeleton}
      qaName={QA_NAME_APPLICANT_DECISION_PANEL}
      ref={anchorRef}
      title={t('RentalPortal.ApplicantDecisionTitleKey')}
    >
      <ApplicantDecisionApplicant onClickAction={handleClickAction} />

      {conflictKey ? (
        <NotificationInline
          qaName={QA_NAME_APPLICANT_DECISION_CONFLICT}
          text={t(conflictKey)}
          type={NOTIFICATION_TYPE.info}
        />
      ) : null}

      <div className={styles.ledger}>
        <ApplicantDecisionSelectionStep />
        <Divider className={styles.divider} />
        <ApplicantDecisionApprovalStep onClickAction={handleClickAction} />
      </div>

      {escalationKey ? (
        <NotificationInline
          qaName={QA_NAME_APPLICANT_DECISION_ESCALATION}
          text={t(escalationKey)}
          type={NOTIFICATION_TYPE.warning}
        />
      ) : null}
    </Widget>
  )
}

export default ApplicantDecisionPanel
